import { NAR, RAT, REC, REP_IMG, SUB } from "../../../Data/typeDirs"
import { genId } from "../../../utils"

const reportBlockSchema = {
  name: 'reportBlockSchema',
  _id: genId(),
  content: [
    {
      name: 'root',
      type: 'Container',
      displaySettings: { as: 'div', className: "schema" },
   
         children: [
        
        {
          name:'container',
          type: 'Container',
          displaySettings: { as: 'div', className:'position-relative' },
   
          children: [
            {
              name:'categoryRow',
              type: 'Container',
              displaySettings: { as: 'div' },
              children: [
                {
                  name: 'categorySelector',
                  type: 'categorySelector',
                  label: 'Category Selector'
                },
              ]
            },  
            {
              name: 'utilsContainer',
              type: 'Container',
              displaySettings: { as: 'div', className: 'block-utils-absolute'},
              children: [
                {
                  name:'utilsRow',
                  type: 'Container',
                  displaySettings:{as:'div'},
                  children:[
                    {name:'reportBlockUtilities', type: 'reportBlockUtilities'}
                  ]
        
                },
              ]
            },          
          ]
        }  ,

        {
          name:'rec_nar_img_container',
          type: 'Container',
          displaySettings: {as: 'Container', className: 'report-narrative-recommendation-container block-body'},
          children: [
            {
              name:'rec_nar_img_row',
              type: 'Container',
              displaySettings: {as: 'Row', className:"report-narrative-recommendation-row"},
              children: [
                
                {
                  name:'recommendationCol',
                  type:'Container',
                  displaySettings: {as: 'Col', sm: 3, className:"report-recommendation-col"},
                  children: [
                    {
                      name:RAT,
                      type:RAT,
                      label:RAT
                    },
                    {
                      name: REC,
                      type: REC,
                      label: 'Recommendations',
                      parent: SUB
                    },
                  ]
                },
                {
                  name: 'narrativeImageCol',
                  type: 'Container',
                  displaySettings: {as: 'Col', sm: 9, className:"report-narrative-col"},
                  children:[
                    {
                      name: NAR,
                      type: NAR,
                      label: 'Narrative',
                      parent: SUB
                    },
                    {
                      name: REP_IMG,
                      type: REP_IMG,
                      label: 'Narrative related images'
                    }
                  ]
                }
              ]
            }
          ]
        }  
      ]
    },

  ]
}

export { reportBlockSchema }